import React, { memo } from 'react';
import { Text } from 'react-native';

import { detectUrlParam } from '../src/urlUtils';
import WebViewBodySiteCanvas from '../components/webview/bodySiteCanvas/WebViewBodySiteCanvas';
import WebViewImageCanvas from '../components/webview/imageCanvas/WebViewImageCanvas';
import webViewNavigatorUtils from './webViewNavigatorUtils';

const types = Object.keys(webViewNavigatorUtils);

const WebViewNavigator = () => {

	const type = detectUrlParam('type');

	return (
		<>
			{type === webViewNavigatorUtils.bodySiteCanvas && <WebViewBodySiteCanvas/>}
			{type === webViewNavigatorUtils.imageCanvas && <WebViewImageCanvas/>}
			{!types.includes(type) && <Text>WebView</Text>}
		</>
	);
};

export default memo(WebViewNavigator);